// Import Link component
import Link from 'components/Link';
import { inject, observer } from 'mobx-react';
import React from 'react';
// Import styles
import styles from './style.scss';

/**
 * AppNavigation component, render only
 */
const AppNavigation = inject('MediahubStore', 'ViewStore')(observer(({ MediahubStore, ViewStore }) => (
  <ul className={styles.nav} >
    {
      _.startsWith(ViewStore.currentPath, '/de') && (
        <li >
          <h3 >
            <Link
              to={'overview'}
              className={ViewStore.isViewActive('overview') ? styles.active : ''} >
              {ViewStore.get('home')}
            </Link >
          </h3 >
        </li >
      )
    }
    {
      _.map(MediahubStore.channelsWithoutFeatured, (c) =>
        c.id !== MediahubStore.mostViewedId &&
        <ChannelMenuItem
          key={c.id}
          channel={c} />,
      )
    }
  </ul >
)));

export default AppNavigation;

const ChannelMenuItem = inject('MediahubStore', 'ViewStore')(observer(({ MediahubStore, ViewStore, channel }) => (
  <li >
    <h3 >
      <Link
        to={'channel'}
        channel={channel.link}
        className={ViewStore.isViewActive('channel', channel.link)
          ? styles.active
          : ''} >
        {channel.title}
      </Link >
    </h3 >
  </li >
)));



// WEBPACK FOOTER //
// ./src/components/AppHeader/Navigation/index.js